// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QuestionCircleFilledSvg from "@ant-design/icons-svg/es/asn/QuestionCircleFilled";
import AntdIcon from '../components/AntdIcon';

var QuestionCircleFilled = function QuestionCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QuestionCircleFilledSvg
  }));
};

QuestionCircleFilled.displayName = 'QuestionCircleFilled';
export default React.forwardRef(QuestionCircleFilled);